import { render, staticRenderFns } from "./TurnIndicator.vue?vue&type=template&id=1e53a8ac&"
import script from "./TurnIndicator.vue?vue&type=script&lang=js&"
export * from "./TurnIndicator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports